import { combineEpics, ofType } from "redux-observable"
import { from, concat, of, EMPTY } from "rxjs"
import { flatMap, debounceTime, catchError, switchMap } from "rxjs/operators"

import * as actions from "./actions"
import { addErrorNotification } from "../notifications/actions"
import { Epic } from "../../epics"
import { RequestCancelledError } from "../../errors"

export const defaultRequestingWorkspacesErrorMessage =
    "Something went wrong when fetching workspaces."

export const requestWorkspacesEpic: Epic = (
    action$,
    state$,
    { workspaceListPage: { workspacesAPI } },
) =>
    action$.pipe(
        ofType(actions.REQUEST_WORKSPACES),
        switchMap(() => {
            const { filter, pagination } = state$.value.workspaceListPage

            return from(workspacesAPI.getWorkspaces(filter, pagination)).pipe(
                flatMap(({ count, workspaces }) =>
                    of(actions.receiveWorkspaces(count, workspaces)),
                ),
                catchError((error) => {
                    if (error instanceof RequestCancelledError) {
                        return EMPTY
                    }
                    console.error(error)
                    return concat(
                        of(actions.receiveWorkspaces(0, [])),
                        of(
                            addErrorNotification(
                                defaultRequestingWorkspacesErrorMessage,
                            ),
                        ),
                    )
                }),
            )
        }),
    )

export const filterWorkspacesEpic: Epic = (
    action$,
    state$,
    { workspaceListPage: { workspacesAPI, filteringDelay } },
) =>
    action$.pipe(
        ofType(actions.FILTER_WORKSPACES),
        debounceTime(filteringDelay),
        switchMap(() => {
            const { filter, pagination } = state$.value.workspaceListPage

            return from(
                workspacesAPI.filterWorkspaces(filter, pagination),
            ).pipe(
                flatMap(({ count, workspaces }) =>
                    of(actions.receiveWorkspaces(count, workspaces)),
                ),
                catchError((error) => {
                    if (error instanceof RequestCancelledError) {
                        return EMPTY
                    }
                    console.error(error)
                    return concat(
                        of(actions.receiveWorkspaces(0, [])),
                        of(
                            addErrorNotification(
                                defaultRequestingWorkspacesErrorMessage,
                            ),
                        ),
                    )
                }),
            )
        }),
    )

export const loadMoreWorkspacesEpic: Epic = (
    action$,
    _state$,
    _dependencies$,
) =>
    action$.pipe(
        ofType(actions.LOAD_MORE_WORKSPACES),
        flatMap(() => of(actions.requestWorkspaces())),
    )

export const refreshWorkspacesEpic: Epic = (action$, _state$, _dependencies$) =>
    action$.pipe(
        ofType(actions.REFRESH_WORKSPACES),
        flatMap(() => of(actions.requestWorkspaces())),
    )

export default combineEpics(
    filterWorkspacesEpic,
    loadMoreWorkspacesEpic,
    refreshWorkspacesEpic,
    requestWorkspacesEpic,
)
